var path = '/templates/zenclerk_s/directives/project_user_activity/user_activity_graph.html';
var html = "<div><svg></svg><div class=activity-graph-tooltip><div class=activity-graph-tooltip-text></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/directives/project_user_activity/user_activity_graph.html
// module id = 1353
// module chunks = 0